<template>
  <a href="/api/rest/profile/diary/download" class="d-flex text-uppercase justify-content-center">{{
    trans("courses.certificate.download")
  }}</a>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  &:hover {
    transition: 0.1s;
    color: $color-orange;
  }
}
</style>
